import React, { useEffect, useMemo, useState } from "react";
import { ujmsV2Statutes } from "../services/ujmsApi";
import { inputCls, selectCls } from "./ui";

const _cache = {};

/** Charge picker backed by the Statutory Authority catalog (Administration › Statutory authority). */
export function OffensePicker({ onPick, preferCategory, caseType, testId }) {
  const key = caseType || "ALL";
  const [rows, setRows] = useState(_cache[key] || []);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (_cache[key]) { setRows(_cache[key]); return; }
    ujmsV2Statutes({ status: "ACTIVE", ...(caseType ? { case_type: caseType } : {}) }).then((r) => { _cache[key] = r.data; setRows(r.data); }).catch(() => {});
  }, [key, caseType]);
  const ql = q.trim().toLowerCase();
  const shown = useMemo(() => (ql ? rows.filter((s) => `${s.charge_id_code} ${s.statute} ${s.full_citation} ${s.short_description} ${s.offense_title} ${s.category}`.toLowerCase().includes(ql)) : rows), [rows, ql]);
  const cats = useMemo(() => {
    const c = [...new Set(shown.map((s) => s.category || "Uncategorized"))].sort();
    return preferCategory && c.includes(preferCategory) ? [preferCategory, ...c.filter((x) => x !== preferCategory)] : c;
  }, [shown, preferCategory]);
  return (
    <div className="flex gap-1 items-center">
      <input className={`${inputCls} !w-40`} placeholder="Filter statutes…" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Filter the statutory authority catalog" data-testid={`${testId}-filter`} />
      <select className={selectCls} value=""
        onChange={(e) => {
          const o = rows.find((s) => s.id === e.target.value);
          if (o) onPick({ statute_code: o.statute, description: o.short_description, classification: o.class_label || "", charge_id_code: o.charge_id_code, full_citation: o.full_citation, offense_title: o.offense_title });
        }}
        aria-label="Pick a charge from the statutory authority catalog" data-testid={testId}>
        <option value="">{`Pick from the Statutory Authority catalog (${shown.length} of ${rows.length})`}</option>
        {cats.map((cat) => (
          <optgroup key={cat} label={cat}>
            {shown.filter((s) => (s.category || "Uncategorized") === cat).map((s) => (
              <option key={s.id} value={s.id}>{`${s.charge_id_code}  ${s.short_description} — ${s.statute} (${s.class_label || "N/A"})`}</option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
